import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from "../states/root.state";
import { deleteCommentApi, getComment, getComments, getSpaComments, postComment, putComment, readComment, resolveCommentApi } from '../../services/api/comments.api';

export const fetchComments = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'comments',
    async (params, {rejectWithValue, getState}) => {
        try {
        const {user} = getState();
        const token = user.accessToken;

        const response = await getComments(token, params);
        return response.data;

        
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching comments.");
            } else {
                return rejectWithValue('An error occurred while fetching comments.');
            }
        }
    }
);

export const fetchComment = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'comment',
    async (id, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await getComment(token, id);
            return response.data;

            
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching comment.");
            } else {
                return rejectWithValue('An error occurred while fetching comment.');
            }
        }
    }
);

export const updateComment = createAsyncThunk<any, {id:string, title:string, category:string, body:string, is_resolved:any, dev_only?: boolean}, { rejectValue: string; state: RootState}>(
    'comment/update',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await putComment(token, updateInfo);

            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while updating comment.");
            } else {
                return rejectWithValue('An error occurred while updating comment.');
            }
        }
    } 

);

export const resolveComment = createAsyncThunk<any, {id:string,is_resolved:any}, { rejectValue: string; state: RootState}>(
    'comment/resolve',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await resolveCommentApi(token, updateInfo);

            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while resolving comment.");
            } else {
                return rejectWithValue('An error occurred while resolving comment.');
            }
        }
    } 

);

export const markAsRead = createAsyncThunk<any, {id:string, params:string, spa_id:string, page:string|undefined}, { rejectValue: string; state: RootState}>(
    'comment/read',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await readComment(token, updateInfo);

            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while marking comment as read.");
            } else {
                return rejectWithValue('An error occurred while marking comment as read.');
            }
        }
    } 

);

export const fetchSpaComments = createAsyncThunk<any, {id:string, params:string}, { rejectValue: string; state: RootState}>(
    'spa/comments',
    async (request, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            const response = await getSpaComments(token, request);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching spa comments.");
            } else {
                return rejectWithValue('An error occurred while fetching spa comments.');
            }
        }
    }
);

export const addComment = createAsyncThunk<any, {title:string, category:string, body:string, spa_id:string, user_id:string, params:string, dev_only?: boolean}, { rejectValue: string; state: RootState}>(
    'comments/post',
    async (comment, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            const response = await postComment(token, comment);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while adding comment." );
            } else {
                return rejectWithValue('An error occurred while adding comment.');
            }
        }
    }
);

export const deleteComment = createAsyncThunk<any, {id:string, spa_id:string,params:string}, { rejectValue: string; state: RootState}>(
    'comment/delete',
    async (comment, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            const response = await deleteCommentApi(token, comment.id);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while deleting comment.");
            } else {
                return rejectWithValue('An error occurred while deleting comment.');
            }
        }
    }
);